import React from 'react';
import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export const LanguageToggle: React.FC = () => {
  const {
    lang,
    toggleLang
  } = useLanguage();
  return <motion.button initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.5
  }} onClick={toggleLang} className="fixed top-6 right-6 z-50 flex items-center space-x-2 bg-white/90 backdrop-blur-md border border-beige-200 shadow-lg px-4 py-2 rounded-full text-dark hover:text-coral-500 hover:border-coral-300 transition-all duration-300" data-id="element-103">
      <Globe className="w-4 h-4" data-id="element-104" />
      <span className="font-sans font-semibold text-sm tracking-wide" data-id="element-105">
        {lang === 'es' ? 'EN' : 'ES'}
      </span>
    </motion.button>;
};